import { ExtractSubjectType, SubjectRawRule } from "@casl/ability";

type BaseEntityActions = "access" | "read" | "edit" | "delete" | "admin";

type JournalActions = "approve" | "sign" | "integration";

export type Actions = BaseEntityActions | JournalActions;

export type Subjects =
  | "company"
  | "project"
  | "object"
  | "acts_service"
  | "contract"
  | "journals_service"
  | "general_work_journal"
  | "act"
  | "title_journals"
  | "main_journals"
  | "section_3"
  | "section_1"
  | "section_2"
  | "section_4";

export type SubjectRule = SubjectRawRule<
  string,
  ExtractSubjectType<Subjects>,
  unknown
>;

export type Permissions = Array<{
  id: string;
  action: string;
  aclName?: string;
}>;

export const PermissionsMap = {
  ADMIN: ["access", "read", "edit", "delete", "admin", "integration", "approve", "sign"],
  ALL_USER: ["access", "read", "edit"],
  ACCESS: ["access"],
  READ: ["read"],
  EDIT: ["edit"],
  DELETE: ["delete"],

  // journal specific actions
  APPROVE: ["approve"],
  SIGN: ["sign"],
  INTEGRATION: ["integration"],
};
